import { useTranslation } from 'react-i18next'
import { ReactNode, useState } from 'react'

import PlainModal, { PlainModalContent, PlainModalFooter } from 'app/common/ui-next/plain-modal'
import { Header2 } from 'app/common/templates-next/page-template'
import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'

import styles from './AgreementToSave.module.scss';

type Props = {
  onAgree: () => void
  onDisagree: () => void
  children: (onClick: () => void) => ReactNode
}

export const AgreementToSave = ({ onAgree, onDisagree, children }: Props) => {
  const { t } = useTranslation('finances')
  const [show, setShow] = useState(false)

  const agree = () => {
    setShow(false)
    onAgree()
  }

  const disagree = () => {
    setShow(false)
    onDisagree()
  }

  if (!show) return children(() => setShow(true))

  return (
    <>
      {children(() => setShow(false))}
      <PlainModal className={styles.root} show>
        <PlainModalContent>
          <Header2 className={styles.header}>
            {t(
              'recurrent_refill_agreement_to_save_header',
              'Сохранить карту для будущих платежей?',
            )}
          </Header2>
          <div className={styles.message}>
            {t('save_card_its_safe', 'Данные ваших карт в безопасности — мы никому их не передаем')}
          </div>
        </PlainModalContent>
        <PlainModalFooter>
          <ControlsBar right>
            <PlainButton onClick={disagree} outline>
              {t('no', 'Нет')}
            </PlainButton>
            <PlainButton onClick={agree}>{t('yes', 'Да')}</PlainButton>
          </ControlsBar>
        </PlainModalFooter>
      </PlainModal>
    </>
  )
}
